import PriceForManual from './PriceForManual';

export default PriceForManual;
